import { elementInView, throttle } from './utils';

const setupAnimateIn = () => {

  const scrollElements = document.querySelectorAll('.animate-in');
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const handleScrollAnimation = () => {
    scrollElements.forEach((el) => {
      if (elementInView(el, 50)) {
        displayScrollElement(el);
      }
    })
  }

  window.addEventListener('scroll', () => {
    if (mediaQuery && !mediaQuery.matches) {
      throttle(handleScrollAnimation(), 250);
    }
  })

  window.onload = () => {
    if (mediaQuery && !mediaQuery.matches) {
     handleScrollAnimation()
    }
  }
  
  window.addEventListener('load', () => {
    if (mediaQuery && !mediaQuery.matches) {
      handleScrollAnimation();
    }
  })
}

const displayScrollElement = (element) => {
  element.classList.add('animated', 'seen');
}

export default setupAnimateIn;
